export const CLOSED = { value: "CLOSED", key: "members.followUps.statusTypes.closed" };
export const OPEN = { value: "OPEN", key: "members.followUps.statusTypes.open" };
export const NEW = { value: "NEW", key: "members.followUps.statusTypes.new"};

export default [CLOSED, OPEN];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/enums/followUpStatusTypes.js